/* eslint-disable */
import React from 'react';
import PaginationComp from '../../../../components/pager/pagination';
import AvatarComp from '../../../../components/helper/avatar';
import { OkrPopUp } from '../../../types/okrpopup.types';
import { replaceLinkWithAnchor } from '../../../../utils/common';
import { withTranslation } from 'react-i18next';
interface OkrHistoryProps extends OkrPopUp {
  rows?: [],
  showSearchBox?: boolean,
  headers?: string[],
  maxPageSize?: number,
  perPageItem?: number,
  url?: string,
}

type OkrHistoryState = {
  totalItems: number,
  rows: [],
  perPageItem?: number,
  url?: string,
  check: boolean,
}

class OKRHistoryComp extends React.Component<OkrHistoryProps, OkrHistoryState> {
    private okrTableWrapperRef = React.createRef<HTMLDivElement>();

    constructor (props: OkrHistoryProps) {
        super(props);
        this.state = {
            totalItems: 0,
            rows: [],
            perPageItem: props.perPageItem,
            url: props.url,
            check: false,
        };
        this.viewGoal = this.viewGoal.bind(this);
    }

    async componentDidMount () {
        const { goalId } = this.props;
        const _this = this;
        if (typeof wbConfig.baseUrl !== 'undefined' && goalId) {
            const contentId = document.getElementById('content');
            showLoaderWidget(contentId);
            await $.ajax({
                url: `${wbConfig.baseUrl}/goal/getOKRHistory?goalId=${goalId}`,
                type: 'get',
                success (response) {
                    if (response.status == 'success') {
                        _this.setState({
                            totalItems: response.totalItems,
                            rows: response.rows,
                            perPageItem: response.perPageItem,
                            url: response.url,
                        });
                    }
                    removeLoader();
                    _this.setState({ check: true })
                },
                error () {
                    removeLoader();
                }
            });
        }
    }

    getHeaders () {
        return this.props.headers;
    }

    getFieldValue (r, field) {
        const value = r[field] || '';
        if (field == 'picture') {
            return <AvatarComp src={value} imageClass="fitProfileImage" useSpriteSheet={false} />
        }
        if (field == 'description') {
            const subtext = typeof r.subtext !== 'undefined' ? r.subtext : '';
            return (
                <div>
                    <div dangerouslySetInnerHTML={{ __html:  replaceLinkWithAnchor(value) }} />
                    {subtext ? (
                        <div
                            className="subtext-wrapper"
                            dangerouslySetInnerHTML={{ __html: subtext }}
                        />
                    ) : (
                        ''
                    )}
                </div>
            );
        }
        if (field == 'link_id') {
            const goalAccess = r.goal_access || false;
            return goalAccess == '1' ? (
                <span
                    role="button"
                    aria-label="Goal id link"
                    className="goal-id-link"
                    tabIndex={0}
                    onClick={e => this.viewGoal(r, e)}
                    onKeyDown={e => this.viewGoal(r, e)}
                    dangerouslySetInnerHTML={{ __html: value }}
                />
            ) : (
                value
            );
        }

        return value;
    }

    renderHistoryField (v, field) {
        const fieldClass = field ? field.toLowerCase() : '';
        return (
            <div className={`okrtable-col okrtable-col-${fieldClass}`}>
                <div>{this.getFieldValue(v, field)}</div>
            </div>
        );
    }

    setPage (number) {
        const params = {
            page: number,
            json: true
        };
        this.getData(params);
    }

    getData (params = {}) {
        if (Object.keys(params).length) {
            const _this = this;
            if ($('#adminAppIndex').length) {
                showLoaderWidget($('#adminAppIndex'));
            } else {
                showLoaderWidget($('#content'));
            }
            const { url } = this.state;
            const isTermSearch = $.ajax({
                url,
                type: 'get',
                data: params
            })
                .done(response => {
                    removeLoader();
                    const rows = response.rows || [];
                    const updateStates = { rows };
                    if (isTermSearch) {
                    // updateStates.totalItems = response.totalItems;
                    }
                    const isPaging = 'page' in params && params.page !== undefined;
                    _this.setState(updateStates, () => {
                        if (isPaging && _this.okrTableWrapperRef.current) {
                            _this.okrTableWrapperRef.current.scrollTop = 0;
                        }
                    });
                })
                .fail(error => {
                    removeLoader();
                    console.log('error');
                });
        }
    }

    viewGoal (r, e) {
        e.preventDefault();
        if (r.goal_id) {
            viewGoalDetailsPage(undefined, { id: r.goal_id });
        }
    }

    searchEvent (e) {
        e.preventDefault();
        const v = e.target.value.trim();
        this.getData({
            term: v,
            json: true
        });
    }

    searchBox () {
        return (
            <div className="okr-history-search-wrapper">
                <input
                    type="text"
                    placeholder="Search..."
                    className="serach-icon"
                    onChange={this.searchEvent.bind(this)}
                />
            </div>
        );
    }

    emptyContent () {
        const { t } = this.props;
        return <div className="empty-content">{t('No records found.')}</div>;
    }

    renderHistoryRow (r) {
        return (
            <li className="okrtable-row">
                {this.getHeaders().map(field => this.renderHistoryField(r, field))}
            </li>
        );
    }

    render () {
        const { rows, check } = this.state;
        return (
            <div className="okrs-history-wrapper wb-ghead-okr_history-wrapper">
                {this.props.showSearchBox ? this.searchBox() : ''}
                <div className="okrtable-wrapper" ref={this.okrTableWrapperRef}>
                    <ol className="okrtable" id="table-wrapper" aria-label="History" tabIndex={-1}>
                        {rows.length
                            ? rows.map(r => this.renderHistoryRow(r))
                            : (check ? this.emptyContent() : '')}
                    </ol>
                </div>
                <PaginationComp
                    totalItems={this.state.totalItems}
                    maxPageSize={this.props.maxPageSize}
                    perPageItem={this.state.perPageItem}
                    setPageEventHandler={this.setPage.bind(this)}
                />
            </div>
        );
    }
}

export default React.memo(withTranslation()(OKRHistoryComp))
